import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Menus } from 'app/shared/constants/menu.constant';
import { AuthGuardService as AuthGuard } from '../../shared/guard/authorization-guard.service';
import { AttendanceComponent } from './attendance.component';

const routes: Routes = [
  {
    path: '',
    component: AttendanceComponent,
    data: { title: 'attendance',menuName: Menus.ATTENDANCE},
    // canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendanceRoutingModule { }